module.exports = __webpack_public_path__ + "img/p17.922d2131.svg";